import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: undefined, // optional 
    ten: undefined, // required Tên nền tảng
    hien_thi: undefined, // required hien thi
    image_id: undefined, // required Id hình ảnh
    dich_vu: undefined, // optional Loại dịch vụ. Tour, Lưu trú, Ẩm thực, Điểm đến, Giải trí
    thoi_diem_tao: undefined, // required Thời gian tạo bản ghi
}

model.validForm = {
    ten: [ValidService.required],
    hien_thi: [ValidService.required],
    image_id: [ValidService.required],
    dich_vu: [ValidService.required], 
}

model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ten: "",
            hien_thi: "",
            dich_vu: ""
        },
        valid: {
            ten: [],
            hien_thi: [],
            dich_vu: []
        },
        operator: {
            ten: "$vn_text=", //:regex:, $vn_text=Viêt nam
            hien_thi: "",
            dich_vu: ""
        }
    }
};

export default model;